<template>
	<div>
		<div  v-loading="loading" class="ask_box">
			<div class="clearfloat"></div>
			<p class="ask_title">非常感谢您索取我公司的宣传资料.请完整填写以下表格， 收到您的信息后我们会尽快安排给您寄出。</p>
			<el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="姓名" prop="name">
					<el-input v-model="ruleForm.name"></el-input>
				</el-form-item>
				<el-form-item label="单位" prop="unit">
					<el-input v-model="ruleForm.unit"></el-input>
				</el-form-item>
				<el-form-item label="专业" prop="specialty">
					<el-input v-model="ruleForm.specialty"></el-input>
				</el-form-item>
				<el-form-item label="课题组" prop="subject">
					<el-input v-model="ruleForm.subject"></el-input>
				</el-form-item>
				<el-form-item label="电子邮件" prop="email">
					<el-input v-model="ruleForm.email"></el-input>
				</el-form-item>
				<el-form-item label="电话" prop="phone">
					<el-input v-model="ruleForm.phone"></el-input>
				</el-form-item>
				<el-form-item class="rfvtgb" label="是否需要技术人员直接联系" prop="relation">
					<el-radio v-model="ruleForm.relation" label="1">是</el-radio>
  					<el-radio v-model="ruleForm.relation" label="0">否</el-radio>
				</el-form-item>
				<el-form-item label="内容" >
					<el-input :autosize="{ minRows: 4, maxRows: 8}" type="textarea" v-model="ruleForm.note"></el-input>
				</el-form-item>
			</el-form>
			<div class="laing_btn tijiao" @click="submitForm('ruleForm')">提交</div>
		</div>
	</div>
</template>

<script>
import {chkEmail,chkMobile} from '@/utlis/formrules'
	export default {
		data() {
			return {
				loading:false,
				isTosub:true,
				ruleForm: {
					name: '',//姓名
					unit: '',//单位
					specialty:'',//专业
					subject:'',//课题组
					email:'',//邮箱
					phone:'',//电话
					relation:'',//是否需要联系
					note:'',//内容
				},
				rules: {
					name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
					unit: [{ required: true, message: '请输入单位', trigger: 'blur' }],
					specialty:{ required: true, message: '请输入专业', trigger: 'blur' },
					subject:{ required: true, message: '请输入课题组', trigger: 'blur' },
					email:[ { required: true, message: '请输入邮箱', trigger: 'blur' }, { validator: chkEmail, trigger: 'blur' }],
					phone:[{ required: true, message: '请输入电话', trigger: 'blur' },{ validator: chkMobile, trigger: 'blur' }],
					relation: [ { required: true, message: '请选择是否需要技术人员联系', trigger: 'change' } ],
					// note:{ required: true, message: '请输入内容', trigger: 'blur' }
				}
			}
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (!valid) return;
					this.loading = true;
					let {code,data,message} = await this.api.Postdemand(this.ruleForm);
					if(code==200)this.$message({ message: '提交成功', type: 'success' });
					this.resetForm();
					this.loading = false;
				});
			},
			resetForm() {
				this.$refs.ruleForm.resetFields();
			}
		}
	}
</script>

<style lang="scss" scoped>
.rfvtgb /deep/ .el-form-item__label{
	width: 200px !important;
}
.rfvtgb /deep/ .el-form-item__content{
	margin-left: 200px !important;
}
	.ask_box {
		width: 655px;
		margin: 0 auto;
		.tijiao{
			width: 210px;
			height: 40px;
			line-height: 40px;
			margin: 0 auto;
		}
		.ask_title {
			margin: 30px 0;
			width: 511px;
			height: 63px;
			font-size: 20px;
			color: #333333;
			line-height: 30px;
		}
	}
</style>
